import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2oar1fmd: FaireBrandEntity = {
  token: "b_2oar1fmd",
  type: "brand",
  name: "Evolve Botanica",
  avatarUrl:
    "https://cdn.faire.com/fastly/baf310bfab10ba6801aba555b916cc7060bb72f538b4eb497b0f8543051e74c5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4884e1b3ae4df3e7a81502932746c1a032333d16872f8e26ee53a7c332ac0680.png",
  logoUrl:
    "https://cdn.faire.com/fastly/baf310bfab10ba6801aba555b916cc7060bb72f538b4eb497b0f8543051e74c5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4884e1b3ae4df3e7a81502932746c1a032333d16872f8e26ee53a7c332ac0680.png",
  location: "Marietta, GA, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 160,
  isInsider: true,
  description:
    "🐰 Leaping Bunny Certified · 🌿 Georgia Grown · 👩 Woman-Owned · 🌲 One Tree Planted Partner · ⭐ 4.9★ on Faire\n\nClean, cruelty-free skincare and gemstone-topped soy candles handcrafted in Marietta, Georgia — and a proven seller in independent boutiques, gift shops, wellness studios, and spa retail.\n\n🌿  Nearly every soap and skincare product we make features an ingredient sourced directly from our Georgia farming and artisan community. Every batch is made by hand, free of parabens, phthalates, sulfates, and petrochemicals — clean beauty your customers can feel good about, and your store can stand behind.\n\n🌲 Every order plants a tree. We're proud partners with One Tree Planted, replanting forests right here in the US with every purchase. For eco-conscious shoppers — and the stores that serve them — this is a story that sells itself at the register.\n\n🦋 Our cohesive product range — artisan soaps, bath bombs, soy candles with gemstone toppers, skincare, roll-ons, perfumes, bath salts, and crystals — merchandises beautifully together and naturally encourages multi-item purchases.\n\nFounded over 20 years ago by Jennifer, rooted in a grandmother's plant wisdom and modern botanical chemistry. Made with intention. Every batch, every time.\n\n✨ Best paired with: crystal and gemstone collections, wellness accessories, clean beauty, artisan gift assortments.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:55.694Z",
    importedBy: "entity-db-cli",
  },
};
